/**
 * Unix username (spec 4.2) — keep in sync with backend unixIdentity/unixUsernameFormat.
 */

export const UNIX_MAX_LEN = 32;

export const UNIX_CASES = Object.freeze({
  NORMAL_BATCH: 'normal_batch',
  NORMAL_NO_BATCH: 'normal_nobatch',
  BULK_WORKSHOP: 'bulk_workshop',
  CHIPGRAD: 'chipgrad',
  VE_TRAINER: 've_trainer',
});

export function programPrefix(program) {
  const letters = String(program || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  if (letters.length >= 2) return letters.slice(0, 2);
  if (letters.length === 1) return letters;
  return 'po';
}

export function slugUnixName(firstName, lastName, fullName) {
  const source =
    [firstName, fullName, lastName]
      .map((value) => String(value || '').trim())
      .find(Boolean) || '';
  const token = source.split(/[\s._-]+/).find(Boolean) || '';
  const slug = token.toLowerCase().replace(/[^a-z0-9]/g, '');
  return slug || 'user';
}

export function unixCenterLetter(center, mode) {
  const normalizedMode = String(mode || '')
    .trim()
    .toLowerCase();
  if (normalizedMode === 'online') return '';
  const raw = String(center || '')
    .trim()
    .toUpperCase();
  if (!raw) return '';
  if (raw.startsWith('NOIDA')) return 'n';
  if (raw.startsWith('BANGAL') || raw.startsWith('BENGAL')) return 'b';
  if (raw.startsWith('MYSUR')) return 'm';
  if (raw.startsWith('CHENNAI')) return 'c';
  if (raw.startsWith('ROORKEE')) return 'r';
  return raw.toLowerCase().replace(/[^a-z]/g, '').charAt(0) || '';
}

export function extractBatchNo(...sources) {
  for (const source of sources) {
    const text = String(source || '').trim();
    if (!text) continue;
    if (/^\d+$/.test(text)) return String(Number(text));
    const batchWord = text.match(/batch[\s#_.:-]*0*(\d+)/i);
    if (batchWord) return String(Number(batchWord[1]));
    const matches = [...text.matchAll(/b\s*0*(\d+)/gi)];
    if (matches.length) return String(Number(matches[matches.length - 1][1]));
  }
  return '';
}

export function mmyyFromDate(date = new Date()) {
  const parsed = date instanceof Date ? date : new Date(date);
  const valid = parsed instanceof Date && !Number.isNaN(parsed.getTime()) ? parsed : new Date();
  const mm = String(valid.getUTCMonth() + 1).padStart(2, '0');
  const yy = String(valid.getUTCFullYear()).slice(-2);
  return `${mm}${yy}`;
}

export function legacyFromStudentId(studentId) {
  const match = String(studentId || '').match(/(\d+)$/);
  if (match) return String(Number(match[1]));
  return '';
}

function clipName(name, max) {
  const slug = String(name || 'user');
  if (max < 1) return 'u';
  return slug.slice(0, max) || 'u';
}

/**
 * Local example for Generate (server assigns the real unique username on preview/save).
 */
export function generatedUnixUsernameHint({
  programType,
  modeOfCourse,
  locationOfCenter,
  firstName,
  lastName,
  batchNumber,
  batchName,
  previewId,
  now = new Date(),
} = {}) {
  const batchNo = extractBatchNo(batchNumber, batchName);
  const name = slugUnixName(firstName, lastName);
  const center = unixCenterLetter(locationOfCenter, modeOfCourse);
  const prog = programPrefix(programType);
  const legacy = legacyFromStudentId(previewId) || '…';
  if (batchNo) {
    return `${prog}_b${batchNo}${center}_${name}_${legacy}`;
  }
  return `${prog}${mmyyFromDate(now)}_${name}_${legacy}`;
}
